import deDE from './snippet/de-DE.json'
import enGB from './snippet/en-GB.json'
import nlNL from './snippet/nl-NL.json'

Shopware.Module.register('sw-category-detail-tab-upselling', {
    snippets: {
        'de-DE': deDE,
        'en-GB': enGB,
        'nl-NL': nlNL
    },

    routeMiddleware(next, currentRoute) {
        if (currentRoute.name === 'sw.category.detail') {
            currentRoute.children.push({
                name: 'sw.category.detail.upselling',
                path: '/sw/category/detail/:id/upselling',
                component: 'sw-category-upselling',
                meta: {
                    parentPath: 'sw.category.index'
                }
            })
        }
        next(currentRoute)
    }
})
